<!--
 * @Description: 协作人配置组件
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <jw-form-item field="isShowCollaborator" :label-col-style="{ width: '120px' }" label-col-flex="auto">
    <template #label>
      <xl-label-text :value="$t('是否展示')" :row="1" />
    </template>
    <jw-radio-group v-model="sendType.modules[0].display" @change="radioChange">
      <jw-radio :value="1">{{ $t('是') }}</jw-radio>
      <jw-radio :value="0">{{ $t('否') }}</jw-radio>
    </jw-radio-group>
  </jw-form-item>
  <!-- 协作人按钮 -->
  <template v-if="sendType?.modules?.[0]?.display === 1">
    <jw-form-item :label-col-style="{ width: '120px' }" label-col-flex="auto" class="btn-form-item">
      <template #label>
        <xl-label-text :value="$t('通用按钮')" :row="1" />
      </template>
      <btn-group :list="getBtnList?.[150]" @cb="onBtnConfigChange" type="150" popup-container=".layout-config-form-content" />
    </jw-form-item>
  </template>
</template>

<script setup>
import { ref, watchEffect } from 'vue';
import btnGroup from '@/views/setting/sys-fields/page-layout/components/btn-group/btn-group.vue'; //操作按钮组合
const emits = defineEmits(['updateData']);
const props = defineProps({
  sendType: {
    type: Object,
    default: () => {}
  },
  followButtonCollection: {
    type: Object,
    default: () => {}
  }
});
const sendType = ref(props.sendType);
const getBtnList = ref(props.followButtonCollection);
watchEffect(() => {
  sendType.value = props.sendType;
  getBtnList.value = props.followButtonCollection;
});

const radioChange = (value) => {
  sendType.value.modules[0].display = value;
  emits('updateData', sendType.value.modules);
};
const onBtnConfigChange = (btnModules) => {
  getBtnList.value[btnModules.type] = btnModules.data;
  sendType.value.modules[0].modules = btnModules.data?.modules?.filter((el) => el?.showField);
  emits('updateData', sendType.value.modules);
};
</script>
<style scoped lang="less">
@import './collaborator-config.less';
</style>
